export default __webpack_public_path__ + "static/logo-576e4c578f260448fa5beb3a255ebf06.png";